<script>
  import {createEventDispatcher} from 'svelte';
  import { ExclamationSquare, X } from 'svelte-bootstrap-icons';

  export let msg;

  const dispatch = createEventDispatcher();

  function cancelAlert() {
    dispatch('cancelalert', {
      hash: msg.hash
    })
  }
  </script>

<div class="ftr-background clearfix border-start border-5 border-top-0 border-bottom-0 border-end-0 border-danger rounded-start-2 p-3 mb-2 shadow-lg">
    
    <span 
      class='float-end ms-1 js-button'
      on:click={cancelAlert}
      on:keypress={cancelAlert}
      role='button'
      tabindex='0'
    >
      <X/>
    </span>    

    {#if msg.title}

        <h6 class='text-danger'>

          { msg.title }

        </h6>    

    {/if}

    {msg.msg}

</div>
